import { render, staticRenderFns } from "./DemoReset.vue?vue&type=template&id=b345c798&"
import script from "./DemoReset.vue?vue&type=script&lang=js&"
export * from "./DemoReset.vue?vue&type=script&lang=js&"
import style0 from "./DemoReset.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports